import { Cloudinary } from "@cloudinary/url-gen";

const CLOUD_NAME = "dskm0wepn";

const cloudinary = new Cloudinary({
  cloud: {
    cloudName: CLOUD_NAME,
  },
  url: {
    secure: true,
  },
});

export const uploadImage = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "redshutter");
  formData.append("api_key", import.meta.env.VITE_CLOUDINARY_APIKEY);

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error("Upload failed");
    }

    const data = await response.json();
    return {
      url: data.secure_url,
      publicId: data.public_id,
    };
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};

export const deleteImage = async (publicId: string) => {
  const timestamp = new Date().getTime();
  const signature = await generateSignature(publicId, timestamp);

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/destroy`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          public_id: publicId,
          signature,
          api_key: import.meta.env.VITE_CLOUDINARY_APIKEY,
          timestamp,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Delete failed");
    }

    return await response.json();
  } catch (error) {
    console.error("Delete error:", error);
    throw error;
  }
};

const generateSignature = async (publicId: string, timestamp: number) => {
  const str = `public_id=${publicId}&timestamp=${timestamp}${
    import.meta.env.VITE_CLOUDINARY_APISECRET
  }`;

  // Using SubtleCrypto for SHA-1 hashing
  const msgUint8 = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest("SHA-1", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return hashHex;
};

export default cloudinary;
